import React, { memo } from 'react'
import tw from 'twin.macro'
import { Button } from 'src/components/shared/Button'
import { GSIcon } from 'src/components/shared/GSIcon'
import { TableSearch } from 'src/components/shared/table/TableSearch'

/** Filtering is in memory, so a short debounce is enough. */
const SEARCH_DEBOUNCE_MS = 200

const HEADER_CONTROL_HEIGHT = 36

interface Props {
  searchQuery: string
  onSearchChange(value: string): void
  onRefresh(): void
}

const RemoteConfigsTableToolbarComponent = ({ searchQuery, onSearchChange, onRefresh }: Props) => {
  return (
    <div
      css={tw`flex flex-row items-center gap-4 rounded-t-lg border-0 border-b border-t border-solid border-shades-100 bg-white px-4 py-3`}
    >
      <TableSearch
        searchQuery={searchQuery}
        onChangeSearchQuery={onSearchChange}
        height={HEADER_CONTROL_HEIGHT}
        debounceMs={SEARCH_DEBOUNCE_MS}
        inputDataTestId="remote-config-search-input"
        clearButtonDataTestId="remote-config-search-clear-btn"
      />
      <div css={tw`ml-auto`}>
        <Button
          size="small"
          color="white"
          leftIcon={<GSIcon iconName="gs_arrows_repeat" size={20} css={tw`text-shades-1000`} />}
          onClick={onRefresh}
          data-testid="remote-config-refresh-button"
        >
          Refresh
        </Button>
      </div>
    </div>
  )
}

export const RemoteConfigsTableToolbar = memo(RemoteConfigsTableToolbarComponent)
